// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__MEpnh","Text":"Footer_Text__kbTZs","Link":"Footer_Link__h5mti"};